import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import classes from "./styles.module.scss";
import { CTA, Description, Image, Title, Video } from "@/ui";
import { Buttons } from "@/ui/Buttons";

export default function SolutionsPanel({
  sectionId,
  className,
  bgColor,
  title,
  titleColor,
  description,
  img,
  buttons,
  video_embed_url,
  reverse,
}) {
  if (!title && !description && !img && !video_embed_url) {
    return null;
  }

  return (
    <div id={sectionId} className={clsx(className, classes.panel, { [classes.panelReverse]: !!reverse })}>
      <Container className={clsx(bgColor, "position-relative mw-xl")}>
        <Row className={clsx("flex-column-reverse", { "flex-md-row-reverse": reverse, "flex-md-row": !reverse })}>
          <Col xs={12} md={video_embed_url ? 7 : 8}>
            <div className="p-4">
              <Title title={title} className={clsx(titleColor, "mb-3")} />
              <Description description={description} />
              <Buttons buttons={buttons} />
            </div>
          </Col>
          <Col xs={12} md={video_embed_url ? 5 : 4}>
            {video_embed_url ? (
              <Video video_embed_url={video_embed_url} />
            ) : img ? (
              <div className={classes.panel__asset}>
                <Image img={img.url} resize={false} alt={img.alt} />
              </div>
            ) : null}
          </Col>
        </Row>
      </Container>
    </div>
  );
}
